import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X, Menu } from 'lucide-react';
import { Footer } from '../Footer';
import i18n from '../../i18n';

interface MainLayoutProps {
  children: React.ReactNode;
  currentStep: number;
}

export default function MainLayout({ children, currentStep }: MainLayoutProps) {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <header className="flex items-center justify-between px-4 py-2 border-b fixed top-0 left-0 right-0 bg-white z-10 h-14">
        <div className="flex items-center space-x-2">
          <img
            src="/logo.jpeg"
            alt="Faucon Bleu"
            className="w-32"
          />
        </div>
        
        <div className="flex items-center space-x-4">
          <button
            className="w-8 h-8 flex items-center justify-center"
            onClick={() => changeLanguage('ar')}
            aria-label="Change language to Arabic"
          >
            <img
              src="https://flagcdn.com/ma.svg"
              alt="Morocco"
              className="h-5 w-auto"
            />
          </button>
          <button
            className="w-8 h-8 flex items-center justify-center"
            onClick={() => changeLanguage('fr')}
            aria-label="Change language to French"
          >
            <img
              src="https://flagcdn.com/fr.svg"
              alt="France"
              className="h-5 w-auto"
            />
          </button>
          <button
            onClick={() => setIsMenuOpen(true)}
            className="p-2"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </header>

      <main style={{paddingBottom:50,paddingTop:50}}className="flex-grow flex flex-col ">
        {children}
      </main>

      {isMenuOpen && (
        <div className="fixed inset-0 bg-white z-50">
          <div className="flex justify-end p-4">
            <button
              onClick={() => setIsMenuOpen(false)}
              className="p-2"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          <nav className="flex flex-col items-center pt-16 space-y-8">
            <MenuLink href="/contact">{t('menu.contact')}</MenuLink>
            <MenuLink href="/instagram">{t('menu.instagram')}</MenuLink>
            <MenuLink href="/faucon-bleu.ma">{t('menu.siteweb')}</MenuLink>
            <MenuLink href="#">{t('menu.application')}</MenuLink>
          </nav>
          {/* Logo */}
          <img
            src="mascot.png"
            alt="Faucon Bleu Mascot"
            className="w-48 h-48 object-contain mb-8 mx-auto"
          />

          {/* Download Section */}
          <div className="w-full">
            <div className="text-center mb-6">
              <span className="text-2xl font-light text-[#2196F3]">
                {t('success.download')}
              </span>
            </div>

            {/* App Store Buttons */}
            <div className="flex justify-center gap-4">
              <a 
                href="#" 
                className="w-[120px] h-[40px] flex items-center justify-center"
                aria-label="Download on App Store" 
              >
                <img
                  src="app-store.png"
                  alt="App Store"
                  className="w-full h-full object-contain mx-auto"
                />
              </a>
              <a 
                href="#" 
                className="w-[120px] h-[40px] flex items-center justify-center"
                aria-label="Get it on Google Play"
              >
                <img
                  src="google-play.png"
                  alt="Google Play"
                  className="w-full h-full object-contain"
                />
              </a>
            </div>
          </div>
        </div>
      )}

      <Footer currentStep={currentStep} />
    </div>
  );
}

function MenuLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <div className="w-full px-4 text-center">
      <a
        href={href}
        className="inline-block w-full text-xl font-light py-2 border-b border-blue-100"
      >
        {children}
      </a>
    </div>
  );
}